var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53303"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 16795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M10 18.667h4v-4.665h4.666v-4H14V5.336h-4v4.666H5.334v4H10Zm-7.334 5.335a2.567 2.567 0 0 1-1.883-.783A2.568 2.568 0 0 1 0 21.336V2.671A2.568 2.568 0 0 1 .783.788 2.568 2.568 0 0 1 2.666.005h18.665a2.568 2.568 0 0 1 1.883.783 2.568 2.568 0 0 1 .783 1.883v18.665a2.568 2.568 0 0 1-.783 1.883 2.567 2.567 0 0 1-1.883.783Zm0-2.666h18.665V2.671H2.666Zm0-18.665Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.6dafaa0bb70dc071a6e04b737785df44.svg";
export { ForwardRef as ReactComponent };